export default __webpack_public_path__ + "static/media/Constancia-entrega-documentos-solidario.61c44939.docx";